import useApplications from './useApplications';

export default useApplications;
